const material = {
  namespaced:true,
  state: () => ({
    codeArr: [], // 选中指标的code数组
    selectedList: [],// 选中指标行数据
    selectedRowKeys: [],
    steps: 0,
    marterArr: [],// 选中原料list
    visible: false, // 多原料抽屉是否显示
    materialCount: 0
  }),
  mutations:{
    setState(state, payload) {
      for (let i in payload) {
        state[i] = payload[i]
      }
    },
    setCount(state){
      state.materialCount++
    }
  }
}

export default material